<template>
    <footer id="footerWrap">
        <div class="footerContentBox">
            <div class="footerList">
                <div>联系我们</div>
                <!-- <span>公司电话：0755-86969845</span> -->
                <span>商务合作：余先生 ylw2539（微信）</span>
                <!-- <span>地址：深圳市南山区前海嘉里中心T1栋703</span> -->
                <span>地址：深圳市南山区西丽街道新高路丰盛商务大厦203室</span>
            </div>
            <div class="footerList notClick">
                <div>通用产品</div>
                <router-link to="/toolSubscription">个性化工具订阅</router-link>
                <router-link to="/riskWarningReport">风险预警报告</router-link>
                <router-link to="/modelFactory">模型工厂</router-link>
                <router-link to="/smartLabel">智能标签</router-link>
                <span>信息核验</span>
                <span>人脸识别</span>
                <span>风险名单过滤</span>
                <!--<router-link to="/InformationCheck">信息核验</router-link>-->
                <!--<router-link to="/faceRecognition">人脸识别</router-link>-->
                <!--<router-link to="/RiskListFiltering">风险名单过滤</router-link>-->
            </div>
            <div class="footerList">
                <div>决策产品</div>
                <router-link to="/znyxSystem">智能营销系统</router-link>
                <router-link to="/znkqdcSystem">智能客群洞察系统</router-link>
            </div>
            <div class="footerList notClick">
                <div>定制产品</div>
                <!--<router-link to="/autobiography">个性化定制</router-link>
                <router-link to="/optimizeEnterprise">企业优化方案定制</router-link>
                <router-link to="/bigDataOperating">大数据操作系统</router-link>-->
                <span>个性化定制</span>
                <span>企业优化方案定制</span>
                <span>大数据操作系统</span>
            </div>
            <!--<div class="footerList">
                <div>帮助与支持</div>
                <router-link to="/apiDocument">API文档</router-link>
                <router-link to="/FAQ">常见问题</router-link>
                <router-link to="/">联系客服</router-link>
            </div>-->
            <div class="footerList">
                <div>关于我们</div>
                <router-link to="/aboutAndJoinUs">公司介绍</router-link>
                <router-link to="/aboutAndJoinUs">愿景和使命</router-link>
                <router-link to="/aboutAndJoinUs">发展历程</router-link>
                <router-link to="/aboutAndJoinUs">加入我们</router-link>
                <!-- <router-link to="/privacyPolicy">隐私政策</router-link> -->
            </div>
        </div>
        <!--办案号-->
        <div class="caseWrap">
            <!-- <div class="caseItem" @click="icpClick" style="cursor: pointer">粤ICP备18018047号</div> -->
            <div class="caseItem" @click="icpClick" style="cursor: pointer">粤ICP备17155642号</div>
            <!-- <div class="caseItem" @click="icpClick" style="cursor: pointer">增值电信业务经营许可证:粤B2-20200518</div> -->
            <!-- <div class="caseItem" @click="ygwClick" style="cursor: pointer">
                <img src="../assets/caseImg.png" height="16" width="14" style="margin-right: 4px;" />
                粤公网安备44030502002028号
            </div> -->
            <div class="caseItem">Copyright© 2016-{{year}}YuShi</div>
            <div class="caseItem">All Rights Reserved.</div>
            <!--<div class="caseItem">深圳市羽拾科技有限公司版权所有</div>-->
        </div>
    </footer>
</template>

<script>
export default {
    name: "footerCom",
    data() {
        return {
            year: new Date().getFullYear()
        }
    },
    mounted() {
        /*淡入淡出效果*/
        window.addEventListener('scroll', this.scrollFun);
        this.scrollFun();
    },
    methods: {
        scrollFun() {
            this.$animate(document.getElementById("footerWrap"), "fadeInUp");
        },
        icpClick() {
            // window.open("https://beian.miit.gov.cn/#/Integrated/index");
            window.open("https://beian.miit.gov.cn/#/Integrated/index");
        },
        ygwClick() {
            window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502002028");
        },
    },
    beforeDestroy() {
        /*销毁监听*/
        window.removeEventListener('scroll', this.scrollFun);
    }
}
</script>

<style lang="scss" scoped>
#footerWrap {
    width: 100%;
    height: 485px;
    padding: 80px 0 0;
    margin-top: 160px;
    background: #1E202B;

    .footerContentBox {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 1200px;
        padding-bottom: 60px;
        margin: 0 auto;
        border-bottom: 1px solid #383842;

        .notClick {
            span {
                color: rgba(255, 255, 255, .3) !important;
                cursor: not-allowed;
            }
        }

        .footerList {
            display: flex;
            flex-direction: column;
            align-items: flex-start;

            div {
                margin-bottom: 39px;
                font-size: 16px;
                font-weight: 400;
                color: rgba(255, 255, 255, .9);
                line-height: 22px;
            }

            span {
                margin-bottom: 14px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(255, 255, 255, .7);
                line-height: 20px;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            a {
                margin-bottom: 14px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(255, 255, 255, .7);
                line-height: 20px;
                cursor: pointer;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }

    .caseWrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        /*padding: 20px 67px;*/
        padding: 20px 0;
        margin: 0 auto;

        .caseItem {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, .7);
            line-height: 20px;
        }
    }
}
</style>
